import { useEffect, useRef, useState } from "react";
import Text from "../../Components/Text/Text";
import { ReactComponent as AccessTimeIcon } from "../../assets/svgs/access-time-icon.svg";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { Link } from "react-router-dom";
import Article1Img from "../../assets/images/home/insights/article-1.png";
import Article2Img from "../../assets/images/home/insights/article-2.png";
import Article3Img from "../../assets/images/home/insights/article-3.png";
import Author1Avatar from "../../assets/images/home/insights/changs-avatar.png";
import Author2Avatar from "../../assets/images/home/insights/steven-avatar.png";

const ARTICLES = [
  {
    title: "Use An Agile Approach — Get Rid Of Your Inefficiencies For Gath...",
    image: Article1Img,
    description:
      "Requirements gathering in software development often proves to be a laborious task for a business ...",
    path: "https://blog.agilelabs.com/use-an-agile-approach-get-rid-of-your-inefficiencies-for-gathering-software-requirements/",
    author: "Sze Tho ChangSheng",
    time: "3 min",
    category: "Agile Development",
    authorAvatar: Author1Avatar
  },
  {
    title: "Customer Journey Map -What Can We Get Out From It?",
    image: Article2Img,
    description:
      "A customer journey map is a graphical representation of a customer’s total interaction and...",
    path: "https://blog.agilelabs.com/customer-journey-map-what-can-we-get-out-from-it/",
    author: "Sze Tho ChangSheng",
    time: "6 min",
    category: "Digital Transformation",
    authorAvatar: Author1Avatar
  },
  {
    title: "The Easy Way To Write A Test Case",
    image: Article3Img,
    description:
      "A lot of junior coders often complained to me that it is very difficult to write a test case even...",
    path: "https://blog.agilelabs.com/the-easy-way-to-write-a-test-case/",
    author: "Steven Yap",
    time: "6 min",
    category: "Learning and Development",
    authorAvatar: Author2Avatar
  },
];

export default function InsightsSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref}>
      <div className="py-[120px] px-4 mx-auto container">
        <Text
          type="h2"
          size="d5"
          className={`mb-[60px] transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >
          Gain the Competitive Edge <br />
          With Expert Insights 
        </Text>
        <div className="gap-12 max-xl:gap-6 grid max-sm:!grid-cols-1 max-xl:grid-cols-2 grid-cols-3">
          {ARTICLES.map((item, index) => (
            <Item key={item.title} index={index} show={show} {...item} />
          ))}
        </div>
        <Link to={'https://blog.agilelabs.com/'} rel="nofollow" target="_blank" className={`flex-1 mt-12 block transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}>
          <Text 
            type="span" 
            className="text-xl relative after:content-[''] inline-block after:inline-block after:w-full after:h-[2px] after:bg-yellow-500 after:absolute after:-bottom-3 after:left-0"
          >
            EXPLORE MORE INSIGHTS
          </Text>
        </Link>
      </div>
    </section>
  );
}

function Item({ title, image, description, path, index, show, authorAvatar, category, author, time}) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <Link to={path} rel="nofollow" target="_blank" className={`flex-1 transition-all duration-700 ${active ? "" : "opacity-0 translate-y-96"}`}>
      <div className="border-primary shadow-sm rounded-xl transition-transform duration-250 ease-in-out hover:-translate-y-1 hover:shadow-lg overflow-hidden">
        <div>
          <img src={image} className="w-full" alt="Agile Labs" />
        </div>
        <div className="pt-6 px-5 pb-8">
          <Text type="span" className="inline-block text-base px-7 py-2.5 bg-grey-300 rounded-lg mb-6">{category}</Text>
          <Text type='h1' size="d2" className="mb-3 min-h-[62px]">{title}</Text>
          <Text type='h1' size="bodyMd min-h-[72px]">{description}</Text>
          <div className="mt-6 flex justify-between items-center">
            <div className="flex gap-3 items-center">
              <img src={authorAvatar} alt="Agile Labs" />
              <Text type="span" className="text-sm">{author}</Text>
            </div>
            <Text className="flex gap-1 text-grey-secondary text-sm items-center"><AccessTimeIcon /> {time}</Text>
          </div>
        </div>
      </div>
    </Link>
  );
}
